var exports = {
  "o": "x93eb46d8--5d63b9--input-row",
  "P": "x93eb46d8--5d63b9--label",
};

module.exports = exports;
